export const DEFAULT_STRETCHY_FIT_DIMENSIONS = { width: '100%', maxHeight: '100%' };
